import { render, staticRenderFns } from "./BlankRepresentative.vue?vue&type=template&id=5a242a17&scoped=true"
import script from "./BlankRepresentative.vue?vue&type=script&lang=js"
export * from "./BlankRepresentative.vue?vue&type=script&lang=js"
import style0 from "./BlankRepresentative.vue?vue&type=style&index=0&id=5a242a17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a242a17",
  null
  
)

export default component.exports